export const ITEM_STRUCTURE_TYPE = "פריט" as const;
export const ITEMS_PATH = "/items";
export const ITEMS_BREADCRUMB = { ledger: "כרטסות", list: "פריטים/מלאי" } as const;
export const ITEMS_STRUCTURE_CRUMBS = {
  browse: "הגדרת מבנה דפדוף",
} as const;